var items = {
  "block.minecraft.air": "ar",
  "block.minecraft.stone": "pedra",
  "block.minecraft.granite": "granito",
  "block.minecraft.polished_granite": "granito polido",
  "block.minecraft.diorite": "diorito",
  "block.minecraft.polished_diorite": "diorito polido",
  "block.minecraft.andesite": "andesito",
  "block.minecraft.polished_andesite": "andesito polido",
  "block.minecraft.grass_block": "bloco de relva",
  "block.minecraft.dirt": "terra",
  "block.minecraft.coarse_dirt": "terra infértil",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "nicélio carmesim",
  "block.minecraft.warped_nylium": "nicélio deformado",
  "block.minecraft.cobblestone": "pedregulho",
  "block.minecraft.oak_planks": "tábuas de carvalho",
  "block.minecraft.spruce_planks": "tábuas de abeto",
  "block.minecraft.birch_planks": "tábuas de bétula",
  "block.minecraft.jungle_planks": "tábuas de madeira da selva",
  "block.minecraft.acacia_planks": "tábuas de acácia",
  "block.minecraft.dark_oak_planks": "tábuas de carvalho escuro",
  "block.minecraft.crimson_planks": "tábuas carmesins",
  "block.minecraft.warped_planks": "tábuas deformadas",
  "block.minecraft.oak_sapling": "rebento de carvalho",
  "block.minecraft.spruce_sapling": "rebento de abeto",
  "block.minecraft.birch_sapling": "rebento de bétula",
  "block.minecraft.jungle_sapling": "rebento da selva",
  "block.minecraft.acacia_sapling": "rebento de acácia",
  "block.minecraft.dark_oak_sapling": "rebento de carvalho escuro",
  "block.minecraft.bedrock": "rocha-mãe",
  "block.minecraft.sand": "areia",
  "block.minecraft.red_sand": "areia vermelha",
  "block.minecraft.gravel": "gravilha",
  "block.minecraft.gold_ore": "minério de ouro",
  "block.minecraft.iron_ore": "minério de ferro",
  "block.minecraft.coal_ore": "minério de carvão",
  "block.minecraft.nether_gold_ore": "minério de ouro do nether",
  "block.minecraft.oak_log": "tronco de carvalho",
  "block.minecraft.spruce_log": "tronco de abeto",
  "block.minecraft.birch_log": "tronco de bétula",
  "block.minecraft.jungle_log": "tronco de árvore da selva",
  "block.minecraft.acacia_log": "tronco de acácia",
  "block.minecraft.dark_oak_log": "tronco de carvalho escuro",
  "block.minecraft.crimson_stem": "pé carmesim",
  "block.minecraft.warped_stem": "pé deformado",
  "block.minecraft.stripped_oak_log": "tronco de carvalho descascado",
  "block.minecraft.stripped_spruce_log": "tronco de abeto descascado",
  "block.minecraft.stripped_birch_log": "tronco de bétula descascado",
  "block.minecraft.stripped_jungle_log": "tronco de árvore da selva descascado",
  "block.minecraft.stripped_acacia_log": "tronco de acácia descascado",
  "block.minecraft.stripped_dark_oak_log": "tronco de carvalho escuro descascado",
  "block.minecraft.stripped_crimson_stem": "pé carmesim descascado",
  "block.minecraft.stripped_warped_stem": "pé deformado descascado",
  "block.minecraft.stripped_oak_wood": "madeira de carvalho descascada",
  "block.minecraft.stripped_spruce_wood": "madeira de abeto descascada",
  "block.minecraft.stripped_birch_wood": "madeira de bétula descascada",
  "block.minecraft.stripped_jungle_wood": "madeira de árvore da selva descascada",
  "block.minecraft.stripped_acacia_wood": "madeira de acácia descascada",
  "block.minecraft.stripped_dark_oak_wood": "madeira de carvalho escuro descascada",
  "block.minecraft.stripped_crimson_hyphae": "hifas carmesins descascadas",
  "block.minecraft.stripped_warped_hyphae": "hifas deformadas descascadas",
  "block.minecraft.oak_wood": "madeira de carvalho",
  "block.minecraft.spruce_wood": "madeira de abeto",
  "block.minecraft.birch_wood": "madeira de bétula",
  "block.minecraft.jungle_wood": "madeira da selva",
  "block.minecraft.acacia_wood": "madeira de acácia",
  "block.minecraft.dark_oak_wood": "madeira de carvalho escuro",
  "block.minecraft.crimson_hyphae": "hifas carmesins",
  "block.minecraft.warped_hyphae": "hifas deformadas",
  "block.minecraft.oak_leaves": "folhas de carvalho",
  "block.minecraft.spruce_leaves": "folhas de abeto",
  "block.minecraft.birch_leaves": "folhas de bétula",
  "block.minecraft.jungle_leaves": "folhas da selva",
  "block.minecraft.acacia_leaves": "folhas de acácia",
  "block.minecraft.dark_oak_leaves": "folhas de carvalho escuro",
  "block.minecraft.sponge": "esponja",
  "block.minecraft.wet_sponge": "esponja húmida",
  "block.minecraft.glass": "vidro",
  "block.minecraft.lapis_ore": "minério de lápis-lazúli",
  "block.minecraft.lapis_block": "bloco de lápis-lazúli",
  "block.minecraft.dispenser": "distribuidor",
  "block.minecraft.sandstone": "arenito",
  "block.minecraft.chiseled_sandstone": "arenito esculpido",
  "block.minecraft.cut_sandstone": "arenito cortado",
  "block.minecraft.note_block": "bloco musical",
  "block.minecraft.powered_rail": "carril elétrico",
  "block.minecraft.detector_rail": "carril detetor",
  "block.minecraft.sticky_piston": "pistão adesivo",
  "block.minecraft.cobweb": "teia de aranha",
  "block.minecraft.grass": "relva",
  "block.minecraft.fern": "feto",
  "block.minecraft.dead_bush": "arbusto morto",
  "block.minecraft.seagrass": "erva marinha",
  "block.minecraft.sea_pickle": "pepino-do-mar",
  "block.minecraft.piston": "pistão",
  "block.minecraft.white_wool": "lã branca",
  "block.minecraft.orange_wool": "lã laranja",
  "block.minecraft.magenta_wool": "lã magenta",
  "block.minecraft.light_blue_wool": "lã azul-clara",
  "block.minecraft.yellow_wool": "lã amarela",
  "block.minecraft.lime_wool": "lã verde-lima",
  "block.minecraft.pink_wool": "lã rosa",
  "block.minecraft.gray_wool": "lã cinzenta",
  "block.minecraft.light_gray_wool": "lã cinzento-clara",
  "block.minecraft.cyan_wool": "lã cíano",
  "block.minecraft.purple_wool": "lã roxa",
  "block.minecraft.blue_wool": "lã azul",
  "block.minecraft.brown_wool": "lã castanha",
  "block.minecraft.green_wool": "lã verde",
  "block.minecraft.red_wool": "lã vermelha",
  "block.minecraft.black_wool": "lã preta",
  "block.minecraft.dandelion": "dente-de-leão",
  "block.minecraft.poppy": "papoila",
  "block.minecraft.blue_orchid": "orquídea azul",
  "block.minecraft.allium": "alho-porro",
  "block.minecraft.azure_bluet": "jasmim",
  "block.minecraft.red_tulip": "tulipa vermelha",
  "block.minecraft.orange_tulip": "tulipa laranja",
  "block.minecraft.white_tulip": "tulipa branca",
  "block.minecraft.pink_tulip": "tulipa rosa",
  "block.minecraft.oxeye_daisy": "margarida",
  "block.minecraft.cornflower": "centáurea",
  "block.minecraft.lily_of_the_valley": "lírio-do-vale",
  "block.minecraft.wither_rose": "rosa do wither",
  "block.minecraft.brown_mushroom": "cogumelo castanho",
  "block.minecraft.red_mushroom": "cogumelo vermelho",
  "block.minecraft.crimson_fungus": "fungo carmesim",
  "block.minecraft.warped_fungus": "fungo deformado",
  "block.minecraft.crimson_roots": "raízes carmesins",
  "block.minecraft.warped_roots": "raízes deformadas",
  "block.minecraft.nether_sprouts": "rebentos do nether",
  "block.minecraft.weeping_vines": "trepadeiras melancólicas",
  "block.minecraft.twisting_vines": "trepadeiras retorcidas",
  "block.minecraft.sugar_cane": "cana-de-açúcar",
  "block.minecraft.kelp": "alga",
  "block.minecraft.bamboo": "bambu",
  "block.minecraft.gold_block": "bloco de ouro",
  "block.minecraft.iron_block": "bloco de ferro",
  "block.minecraft.oak_slab": "degrau de carvalho",
  "block.minecraft.spruce_slab": "degrau de abeto",
  "block.minecraft.birch_slab": "degrau de bétula",
  "block.minecraft.jungle_slab": "degrau de madeira da selva",
  "block.minecraft.acacia_slab": "degrau de acácia",
  "block.minecraft.dark_oak_slab": "degrau de carvalho escuro",
  "block.minecraft.crimson_slab": "degrau carmesim",
  "block.minecraft.warped_slab": "degrau deformado",
  "block.minecraft.stone_slab": "degrau de pedra",
  "block.minecraft.smooth_stone_slab": "degrau de pedra lisa",
  "block.minecraft.sandstone_slab": "degrau de arenito",
  "block.minecraft.cut_sandstone_slab": "degrau de arenito cortado",
  "block.minecraft.petrified_oak_slab": "degrau de carvalho petrificado",
  "block.minecraft.cobblestone_slab": "degrau de pedregulho",
  "block.minecraft.brick_slab": "degrau de tijolos",
  "block.minecraft.stone_brick_slab": "degrau de tijolos de pedra",
  "block.minecraft.nether_brick_slab": "degrau de tijolos do nether",
  "block.minecraft.quartz_slab": "degrau de quartzo",
  "block.minecraft.red_sandstone_slab": "degrau de arenito vermelho",
  "block.minecraft.cut_red_sandstone_slab": "degrau de arenito vermelho cortado",
  "block.minecraft.purpur_slab": "degrau de púrpura",
  "block.minecraft.prismarine_slab": "degrau de prismarinho",
  "block.minecraft.prismarine_brick_slab": "degrau de tijolos de prismarinho",
  "block.minecraft.dark_prismarine_slab": "degrau de prismarinho escuro",
  "block.minecraft.smooth_quartz": "bloco de quartzo liso",
  "block.minecraft.smooth_red_sandstone": "arenito vermelho liso",
  "block.minecraft.smooth_sandstone": "arenito liso",
  "block.minecraft.smooth_stone": "pedra lisa",
  "block.minecraft.bricks": "tijolos",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "estante de livros",
  "block.minecraft.mossy_cobblestone": "pedregulho com musgo",
  "block.minecraft.obsidian": "obsidiana",
  "block.minecraft.torch": "tocha",
  "block.minecraft.end_rod": "bastão do end",
  "block.minecraft.chorus_plant": "planta do coro",
  "block.minecraft.chorus_flower": "flor do coro",
  "block.minecraft.purpur_block": "bloco de púrpura",
  "block.minecraft.purpur_pillar": "pilar de púrpura",
  "block.minecraft.purpur_stairs": "escadas de púrpura",
  "block.minecraft.spawner": "gerador",
  "block.minecraft.oak_stairs": "escadas de carvalho",
  "block.minecraft.chest": "baú",
  "block.minecraft.diamond_ore": "minério de diamante",
  "block.minecraft.diamond_block": "bloco de diamante",
  "block.minecraft.crafting_table": "mesa de trabalho",
  "block.minecraft.farmland": "terra arada",
  "block.minecraft.furnace": "fornalha",
  "block.minecraft.ladder": "escada de mão",
  "block.minecraft.rail": "carril",
  "block.minecraft.cobblestone_stairs": "escadas de pedregulho",
  "block.minecraft.lever": "alavanca",
  "block.minecraft.stone_pressure_plate": "placa de pressão de pedra",
  "block.minecraft.oak_pressure_plate": "placa de pressão de carvalho",
  "block.minecraft.spruce_pressure_plate": "placa de pressão de abeto",
  "block.minecraft.birch_pressure_plate": "placa de pressão de bétula",
  "block.minecraft.jungle_pressure_plate": "placa de pressão de madeira da selva",
  "block.minecraft.acacia_pressure_plate": "placa de pressão de acácia",
  "block.minecraft.dark_oak_pressure_plate": "placa de pressão de carvalho escuro",
  "block.minecraft.crimson_pressure_plate": "placa de pressão carmesim",
  "block.minecraft.warped_pressure_plate": "placa de pressão deformada",
  "block.minecraft.polished_blackstone_pressure_plate": "placa de pressão de negrito polido",
  "block.minecraft.redstone_ore": "minério de redstone",
  "block.minecraft.redstone_torch": "tocha de redstone",
  "block.minecraft.snow": "neve",
  "block.minecraft.ice": "gelo",
  "block.minecraft.snow_block": "bloco de neve",
  "block.minecraft.cactus": "cato",
  "block.minecraft.clay": "barro",
  "block.minecraft.jukebox": "jukebox",
  "block.minecraft.oak_fence": "cerca de carvalho",
  "block.minecraft.spruce_fence": "cerca de abeto",
  "block.minecraft.birch_fence": "cerca de bétula",
  "block.minecraft.jungle_fence": "cerca de madeira da selva",
  "block.minecraft.acacia_fence": "cerca de acácia",
  "block.minecraft.dark_oak_fence": "cerca de carvalho escuro",
  "block.minecraft.crimson_fence": "cerca carmesim",
  "block.minecraft.warped_fence": "cerca deformada",
  "block.minecraft.pumpkin": "abóbora",
  "block.minecraft.carved_pumpkin": "abóbora talhada",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "areia das almas",
  "block.minecraft.soul_soil": "terra das almas",
  "block.minecraft.basalt": "basalto",
  "block.minecraft.polished_basalt": "basalto polido",
  "block.minecraft.soul_torch": "tocha das almas",
  "block.minecraft.glowstone": "pedra luminosa",
  "block.minecraft.jack_o_lantern": "abóbora de halloween",
  "block.minecraft.oak_trapdoor": "alçapão de carvalho",
  "block.minecraft.spruce_trapdoor": "alçapão de abeto",
  "block.minecraft.birch_trapdoor": "alçapão de bétula",
  "block.minecraft.jungle_trapdoor": "alçapão de madeira da selva",
  "block.minecraft.acacia_trapdoor": "alçapão de acácia",
  "block.minecraft.dark_oak_trapdoor": "alçapão de carvalho escuro",
  "block.minecraft.crimson_trapdoor": "alçapão carmesim",
  "block.minecraft.warped_trapdoor": "alçapão deformado",
  "block.minecraft.infested_stone": "pedra infestada",
  "block.minecraft.infested_cobblestone": "pedregulho infestado",
  "block.minecraft.infested_stone_bricks": "tijolos de pedra infestados",
  "block.minecraft.infested_mossy_stone_bricks": "tijolos de pedra com musgo infestados",
  "block.minecraft.infested_cracked_stone_bricks": "tijolos de pedra rachados infestados",
  "block.minecraft.infested_chiseled_stone_bricks": "tijolos de pedra esculpidos infestados",
  "block.minecraft.stone_bricks": "tijolos de pedra",
  "block.minecraft.mossy_stone_bricks": "tijolos de pedra com musgo",
  "block.minecraft.cracked_stone_bricks": "tijolos de pedra rachados",
  "block.minecraft.chiseled_stone_bricks": "tijolos de pedra esculpidos",
  "block.minecraft.brown_mushroom_block": "bloco de cogumelo castanho",
  "block.minecraft.red_mushroom_block": "bloco de cogumelo vermelho",
  "block.minecraft.mushroom_stem": "pé de cogumelo",
  "block.minecraft.iron_bars": "grades de ferro",
  "block.minecraft.chain": "corrente",
  "block.minecraft.glass_pane": "vidraça",
  "block.minecraft.melon": "melancia",
  "block.minecraft.vine": "trepadeiras",
  "block.minecraft.oak_fence_gate": "portão de carvalho",
  "block.minecraft.spruce_fence_gate": "portão de abeto",
  "block.minecraft.birch_fence_gate": "portão de bétula",
  "block.minecraft.jungle_fence_gate": "portão de madeira da selva",
  "block.minecraft.acacia_fence_gate": "portão de acácia",
  "block.minecraft.dark_oak_fence_gate": "portão de carvalho escuro",
  "block.minecraft.crimson_fence_gate": "portão carmesim",
  "block.minecraft.warped_fence_gate": "portão deformado",
  "block.minecraft.brick_stairs": "escadas de tijolos",
  "block.minecraft.stone_brick_stairs": "escadas de tijolos de pedra",
  "block.minecraft.mycelium": "micélio",
  "block.minecraft.lily_pad": "nenúfar",
  "block.minecraft.nether_bricks": "tijolos do nether",
  "block.minecraft.cracked_nether_bricks": "tijolos do nether rachados",
  "block.minecraft.chiseled_nether_bricks": "tijolos do nether esculpidos",
  "block.minecraft.nether_brick_fence": "cerca de tijolos do nether",
  "block.minecraft.nether_brick_stairs": "escadas de tijolos do nether",
  "block.minecraft.enchanting_table": "mesa de encantamentos",
  "block.minecraft.end_portal_frame": "borda do portal do end",
  "block.minecraft.end_stone": "pedra do end",
  "block.minecraft.end_stone_bricks": "tijolos de pedra do end",
  "block.minecraft.dragon_egg": "ovo do dragão",
  "block.minecraft.redstone_lamp": "lâmpada de redstone",
  "block.minecraft.sandstone_stairs": "escadas de arenito",
  "block.minecraft.emerald_ore": "minério de esmeralda",
  "block.minecraft.ender_chest": "baú do ender",
  "block.minecraft.tripwire_hook": "gancho de fio armadilhado",
  "block.minecraft.emerald_block": "bloco de esmeralda",
  "block.minecraft.spruce_stairs": "escadas de abeto",
  "block.minecraft.birch_stairs": "escadas de bétula",
  "block.minecraft.jungle_stairs": "escadas de madeira da selva",
  "block.minecraft.crimson_stairs": "escadas carmesins",
  "block.minecraft.warped_stairs": "escadas deformadas",
  "block.minecraft.command_block": "bloco de comando",
  "block.minecraft.beacon": "sinalizador",
  "block.minecraft.cobblestone_wall": "muro de pedregulho",
  "block.minecraft.mossy_cobblestone_wall": "muro de pedregulho com musgo",
  "block.minecraft.brick_wall": "muro de tijolos",
  "block.minecraft.prismarine_wall": "muro de prismarinho",
  "block.minecraft.red_sandstone_wall": "muro de arenito vermelho",
  "block.minecraft.mossy_stone_brick_wall": "muro de tijolos de pedra com musgo",
  "block.minecraft.granite_wall": "muro de granito",
  "block.minecraft.stone_brick_wall": "muro de tijolos de pedra",
  "block.minecraft.nether_brick_wall": "muro de tijolos do nether",
  "block.minecraft.andesite_wall": "muro de andesito",
  "block.minecraft.red_nether_brick_wall": "muro de tijolos vermelhos do nether",
  "block.minecraft.sandstone_wall": "muro de arenito",
  "block.minecraft.end_stone_brick_wall": "muro de tijolos de pedra do end",
  "block.minecraft.diorite_wall": "muro de diorito",
  "block.minecraft.blackstone_wall": "muro de negrito",
  "block.minecraft.polished_blackstone_wall": "muro de negrito polido",
  "block.minecraft.polished_blackstone_brick_wall": "muro de tijolos de negrito polido",
  "block.minecraft.stone_button": "botão de pedra",
  "block.minecraft.oak_button": "botão de carvalho",
  "block.minecraft.spruce_button": "botão de abeto",
  "block.minecraft.birch_button": "botão de bétula",
  "block.minecraft.jungle_button": "botão de madeira da selva",
  "block.minecraft.acacia_button": "botão de acácia",
  "block.minecraft.dark_oak_button": "botão de carvalho escuro",
  "block.minecraft.crimson_button": "botão carmesim",
  "block.minecraft.warped_button": "botão deformado",
  "block.minecraft.polished_blackstone_button": "botão de negrito polido",
  "block.minecraft.anvil": "bigorna",
  "block.minecraft.chipped_anvil": "bigorna lascada",
  "block.minecraft.damaged_anvil": "bigorna danificada",
  "block.minecraft.trapped_chest": "baú armadilhado",
  "block.minecraft.light_weighted_pressure_plate": "placa de pressão medidora leve",
  "block.minecraft.heavy_weighted_pressure_plate": "placa de pressão medidora pesada",
  "block.minecraft.daylight_detector": "detetor de luz solar",
  "block.minecraft.redstone_block": "bloco de redstone",
  "block.minecraft.nether_quartz_ore": "minério de quartzo do nether",
  "block.minecraft.hopper": "funil",
  "block.minecraft.chiseled_quartz_block": "bloco de quartzo esculpido",
  "block.minecraft.quartz_block": "bloco de quartzo",
  "block.minecraft.quartz_bricks": "tijolos de quartzo",
  "block.minecraft.quartz_pillar": "pilar de quartzo",
  "block.minecraft.quartz_stairs": "escadas de quartzo",
  "block.minecraft.activator_rail": "carril ativador",
  "block.minecraft.dropper": "ejetor",
  "block.minecraft.white_terracotta": "terracota branca",
  "block.minecraft.orange_terracotta": "terracota laranja",
  "block.minecraft.magenta_terracotta": "terracota magenta",
  "block.minecraft.light_blue_terracotta": "terracota azul-clara",
  "block.minecraft.yellow_terracotta": "terracota amarela",
  "block.minecraft.lime_terracotta": "terracota verde-lima",
  "block.minecraft.pink_terracotta": "terracota rosa",
  "block.minecraft.gray_terracotta": "terracota cinzenta",
  "block.minecraft.light_gray_terracotta": "terracota cinzento-clara",
  "block.minecraft.cyan_terracotta": "terracota cíano",
  "block.minecraft.purple_terracotta": "terracota roxa",
  "block.minecraft.blue_terracotta": "terracota azul",
  "block.minecraft.brown_terracotta": "terracota castanha",
  "block.minecraft.green_terracotta": "terracota verde",
  "block.minecraft.red_terracotta": "terracota vermelha",
  "block.minecraft.black_terracotta": "terracota preta",
  "block.minecraft.barrier": "barreira",
  "block.minecraft.iron_trapdoor": "alçapão de ferro",
  "block.minecraft.hay_block": "fardo de feno",
  "block.minecraft.white_carpet": "tapete branco",
  "block.minecraft.orange_carpet": "tapete laranja",
  "block.minecraft.magenta_carpet": "tapete magenta",
  "block.minecraft.light_blue_carpet": "tapete azul-claro",
  "block.minecraft.yellow_carpet": "tapete amarelo",
  "block.minecraft.lime_carpet": "tapete verde-lima",
  "block.minecraft.pink_carpet": "tapete rosa",
  "block.minecraft.gray_carpet": "tapete cinzento",
  "block.minecraft.light_gray_carpet": "tapete cinzento-claro",
  "block.minecraft.cyan_carpet": "tapete cíano",
  "block.minecraft.purple_carpet": "tapete roxo",
  "block.minecraft.blue_carpet": "tapete azul",
  "block.minecraft.brown_carpet": "tapete castanho",
  "block.minecraft.green_carpet": "tapete verde",
  "block.minecraft.red_carpet": "tapete vermelho",
  "block.minecraft.black_carpet": "tapete preto",
  "block.minecraft.terracotta": "terracota",
  "block.minecraft.coal_block": "bloco de carvão",
  "block.minecraft.packed_ice": "gelo compactado",
  "block.minecraft.acacia_stairs": "escadas de acácia",
  "block.minecraft.dark_oak_stairs": "escadas de carvalho escuro",
  "block.minecraft.slime_block": "bloco de slime",
  "block.minecraft.grass_path": "caminho de relva",
  "block.minecraft.sunflower": "girassol",
  "block.minecraft.lilac": "lilás",
  "block.minecraft.rose_bush": "roseira",
  "block.minecraft.peony": "peónia",
  "block.minecraft.tall_grass": "relva alta",
  "block.minecraft.large_fern": "feto grande",
  "block.minecraft.white_stained_glass": "vidro branco",
  "block.minecraft.orange_stained_glass": "vidro laranja",
  "block.minecraft.magenta_stained_glass": "vidro magenta",
  "block.minecraft.light_blue_stained_glass": "vidro azul-claro",
  "block.minecraft.yellow_stained_glass": "vidro amarelo",
  "block.minecraft.lime_stained_glass": "vidro verde-lima",
  "block.minecraft.pink_stained_glass": "vidro rosa",
  "block.minecraft.gray_stained_glass": "vidro cinzento",
  "block.minecraft.light_gray_stained_glass": "vidro cinzento-claro",
  "block.minecraft.cyan_stained_glass": "vidro cíano",
  "block.minecraft.purple_stained_glass": "vidro roxo",
  "block.minecraft.blue_stained_glass": "vidro azul",
  "block.minecraft.brown_stained_glass": "vidro castanho",
  "block.minecraft.green_stained_glass": "vidro verde",
  "block.minecraft.red_stained_glass": "vidro vermelho",
  "block.minecraft.black_stained_glass": "vidro preto",
  "block.minecraft.white_stained_glass_pane": "vidraça branca",
  "block.minecraft.orange_stained_glass_pane": "vidraça laranja",
  "block.minecraft.magenta_stained_glass_pane": "vidraça magenta",
  "block.minecraft.light_blue_stained_glass_pane": "vidraça azul-clara",
  "block.minecraft.yellow_stained_glass_pane": "vidraça amarela",
  "block.minecraft.lime_stained_glass_pane": "vidraça verde-lima",
  "block.minecraft.pink_stained_glass_pane": "vidraça rosa",
  "block.minecraft.gray_stained_glass_pane": "vidraça cinzenta",
  "block.minecraft.light_gray_stained_glass_pane": "vidraça cinzento-clara",
  "block.minecraft.cyan_stained_glass_pane": "vidraça cíano",
  "block.minecraft.purple_stained_glass_pane": "vidraça roxa",
  "block.minecraft.blue_stained_glass_pane": "vidraça azul",
  "block.minecraft.brown_stained_glass_pane": "vidraça castanha",
  "block.minecraft.green_stained_glass_pane": "vidraça verde",
  "block.minecraft.red_stained_glass_pane": "vidraça vermelha",
  "block.minecraft.black_stained_glass_pane": "vidraça preta",
  "block.minecraft.prismarine": "prismarinho",
  "block.minecraft.prismarine_bricks": "tijolos de prismarinho",
  "block.minecraft.dark_prismarine": "prismarinho escuro",
  "block.minecraft.prismarine_stairs": "escadas de prismarinho",
  "block.minecraft.prismarine_brick_stairs": "escadas de tijolos de prismarinho",
  "block.minecraft.dark_prismarine_stairs": "escadas de prismarinho escuro",
  "block.minecraft.sea_lantern": "lanterna marinha",
  "block.minecraft.red_sandstone": "arenito vermelho",
  "block.minecraft.chiseled_red_sandstone": "arenito vermelho esculpido",
  "block.minecraft.cut_red_sandstone": "arenito vermelho cortado",
  "block.minecraft.red_sandstone_stairs": "escadas de arenito vermelho",
  "block.minecraft.repeating_command_block": "bloco de comando repetitivo",
  "block.minecraft.chain_command_block": "bloco de comando em cadeia",
  "block.minecraft.magma_block": "bloco de magma",
  "block.minecraft.nether_wart_block": "bloco de fungos do nether",
  "block.minecraft.warped_wart_block": "bloco de fungos deformados",
  "block.minecraft.red_nether_bricks": "tijolos vermelhos do nether",
  "block.minecraft.bone_block": "bloco de osso",
  "block.minecraft.structure_void": "vazio da estrutura",
  "block.minecraft.observer": "observador",
  "block.minecraft.shulker_box": "caixa de shulker",
  "block.minecraft.white_shulker_box": "caixa de shulker branca",
  "block.minecraft.orange_shulker_box": "caixa de shulker laranja",
  "block.minecraft.magenta_shulker_box": "caixa de shulker magenta",
  "block.minecraft.light_blue_shulker_box": "caixa de shulker azul-clara",
  "block.minecraft.yellow_shulker_box": "caixa de shulker amarela",
  "block.minecraft.lime_shulker_box": "caixa de shulker verde-lima",
  "block.minecraft.pink_shulker_box": "caixa de shulker rosa",
  "block.minecraft.gray_shulker_box": "caixa de shulker cinzenta",
  "block.minecraft.light_gray_shulker_box": "caixa de shulker cinzento-clara",
  "block.minecraft.cyan_shulker_box": "caixa de shulker cíano",
  "block.minecraft.purple_shulker_box": "caixa de shulker roxa",
  "block.minecraft.blue_shulker_box": "caixa de shulker azul",
  "block.minecraft.brown_shulker_box": "caixa de shulker castanha",
  "block.minecraft.green_shulker_box": "caixa de shulker verde",
  "block.minecraft.red_shulker_box": "caixa de shulker vermelha",
  "block.minecraft.black_shulker_box": "caixa de shulker preta",
  "block.minecraft.white_glazed_terracotta": "mosaico branco",
  "block.minecraft.orange_glazed_terracotta": "mosaico laranja",
  "block.minecraft.magenta_glazed_terracotta": "mosaico magenta",
  "block.minecraft.light_blue_glazed_terracotta": "mosaico azul-claro",
  "block.minecraft.yellow_glazed_terracotta": "mosaico amarelo",
  "block.minecraft.lime_glazed_terracotta": "mosaico verde-lima",
  "block.minecraft.pink_glazed_terracotta": "mosaico rosa",
  "block.minecraft.gray_glazed_terracotta": "mosaico cinzento",
  "block.minecraft.light_gray_glazed_terracotta": "mosaico cinzento-claro",
  "block.minecraft.cyan_glazed_terracotta": "mosaico cíano",
  "block.minecraft.purple_glazed_terracotta": "mosaico roxo",
  "block.minecraft.blue_glazed_terracotta": "mosaico azul",
  "block.minecraft.brown_glazed_terracotta": "mosaico castanho",
  "block.minecraft.green_glazed_terracotta": "mosaico verde",
  "block.minecraft.red_glazed_terracotta": "mosaico vermelho",
  "block.minecraft.black_glazed_terracotta": "mosaico preto",
  "block.minecraft.white_concrete": "betão branco",
  "block.minecraft.orange_concrete": "betão laranja",
  "block.minecraft.magenta_concrete": "betão magenta",
  "block.minecraft.light_blue_concrete": "betão azul-claro",
  "block.minecraft.yellow_concrete": "betão amarelo",
  "block.minecraft.lime_concrete": "betão verde-lima",
  "block.minecraft.pink_concrete": "betão rosa",
  "block.minecraft.gray_concrete": "betão cinzento",
  "block.minecraft.light_gray_concrete": "betão cinzento-claro",
  "block.minecraft.cyan_concrete": "betão cíano",
  "block.minecraft.purple_concrete": "betão roxo",
  "block.minecraft.blue_concrete": "betão azul",
  "block.minecraft.brown_concrete": "betão castanho",
  "block.minecraft.green_concrete": "betão verde",
  "block.minecraft.red_concrete": "betão vermelho",
  "block.minecraft.black_concrete": "betão preto",
  "block.minecraft.white_concrete_powder": "betão branco em pó",
  "block.minecraft.orange_concrete_powder": "betão laranja em pó",
  "block.minecraft.magenta_concrete_powder": "betão magenta em pó",
  "block.minecraft.light_blue_concrete_powder": "betão azul-claro em pó",
  "block.minecraft.yellow_concrete_powder": "betão amarelo em pó",
  "block.minecraft.lime_concrete_powder": "betão verde-lima em pó",
  "block.minecraft.pink_concrete_powder": "betão rosa em pó",
  "block.minecraft.gray_concrete_powder": "betão cinzento em pó",
  "block.minecraft.light_gray_concrete_powder": "betão cinzento-claro em pó",
  "block.minecraft.cyan_concrete_powder": "betão cíano em pó",
  "block.minecraft.purple_concrete_powder": "betão roxo em pó",
  "block.minecraft.blue_concrete_powder": "betão azul em pó",
  "block.minecraft.brown_concrete_powder": "betão castanho em pó",
  "block.minecraft.green_concrete_powder": "betão verde em pó",
  "block.minecraft.red_concrete_powder": "betão vermelho em pó",
  "block.minecraft.black_concrete_powder": "betão preto em pó",
  "block.minecraft.turtle_egg": "ovo de tartaruga",
  "block.minecraft.dead_tube_coral_block": "bloco de coral-tubular morto",
  "block.minecraft.dead_brain_coral_block": "bloco de coral-cérebro morto",
  "block.minecraft.dead_bubble_coral_block": "bloco de coral-bolha morto",
  "block.minecraft.dead_fire_coral_block": "bloco de coral-de-fogo morto",
  "block.minecraft.dead_horn_coral_block": "bloco de coral-corno-de-cervo morto",
  "block.minecraft.tube_coral_block": "bloco de coral-tubular",
  "block.minecraft.brain_coral_block": "bloco de coral-cérebro",
  "block.minecraft.bubble_coral_block": "bloco de coral-bolha",
  "block.minecraft.fire_coral_block": "bloco de coral-de-fogo",
  "block.minecraft.horn_coral_block": "bloco de coral-corno-de-cervo",
  "block.minecraft.tube_coral": "coral-tubular",
  "block.minecraft.brain_coral": "coral-cérebro",
  "block.minecraft.bubble_coral": "coral-bolha",
  "block.minecraft.fire_coral": "coral-de-fogo",
  "block.minecraft.horn_coral": "coral-corno-de-cervo",
  "block.minecraft.dead_brain_coral": "coral-cérebro morto",
  "block.minecraft.dead_bubble_coral": "coral-bolha morto",
  "block.minecraft.dead_fire_coral": "coral-de-fogo morto",
  "block.minecraft.dead_horn_coral": "coral-corno-de-cervo morto",
  "block.minecraft.dead_tube_coral": "coral-tubular morto",
  "block.minecraft.tube_coral_fan": "gorgónia-tubular",
  "block.minecraft.brain_coral_fan": "gorgónia-cérebro",
  "block.minecraft.bubble_coral_fan": "gorgónia-bolha",
  "block.minecraft.fire_coral_fan": "gorgónia-de-fogo",
  "block.minecraft.horn_coral_fan": "gorgónia-corno-de-cervo",
  "block.minecraft.dead_tube_coral_fan": "gorgónia-tubular morta",
  "block.minecraft.dead_brain_coral_fan": "gorgónia-cérebro morta",
  "block.minecraft.dead_bubble_coral_fan": "gorgónia-bolha morta",
  "block.minecraft.dead_fire_coral_fan": "gorgónia-de-fogo morta",
  "block.minecraft.dead_horn_coral_fan": "gorgónia-corno-de-cervo morta",
  "block.minecraft.blue_ice": "gelo azul",
  "block.minecraft.conduit": "conduto",
  "block.minecraft.polished_granite_stairs": "escadas de granito polido",
  "block.minecraft.smooth_red_sandstone_stairs": "escadas de arenito vermelho liso",
  "block.minecraft.mossy_stone_brick_stairs": "escadas de tijolos de pedra com musgo",
  "block.minecraft.polished_diorite_stairs": "escadas de diorito polido",
  "block.minecraft.mossy_cobblestone_stairs": "escadas de pedregulho com musgo",
  "block.minecraft.end_stone_brick_stairs": "escadas de tijolos de pedra do end",
  "block.minecraft.stone_stairs": "escadas de pedra",
  "block.minecraft.smooth_sandstone_stairs": "escadas de arenito liso",
  "block.minecraft.smooth_quartz_stairs": "escadas de quartzo liso",
  "block.minecraft.granite_stairs": "escadas de granito",
  "block.minecraft.andesite_stairs": "escadas de andesito",
  "block.minecraft.red_nether_brick_stairs": "escadas de tijolos vermelhos do nether",
  "block.minecraft.polished_andesite_stairs": "escadas de andesito polido",
  "block.minecraft.diorite_stairs": "escadas de diorito",
  "block.minecraft.polished_granite_slab": "degrau de granito polido",
  "block.minecraft.smooth_red_sandstone_slab": "degrau de arenito vermelho liso",
  "block.minecraft.mossy_stone_brick_slab": "degrau de tijolos de pedra com musgo",
  "block.minecraft.polished_diorite_slab": "degrau de diorito polido",
  "block.minecraft.mossy_cobblestone_slab": "degrau de pedregulho com musgo",
  "block.minecraft.end_stone_brick_slab": "degrau de tijolos de pedra do end",
  "block.minecraft.smooth_sandstone_slab": "degrau de arenito liso",
  "block.minecraft.smooth_quartz_slab": "degrau de quartzo liso",
  "block.minecraft.granite_slab": "degrau de granito",
  "block.minecraft.andesite_slab": "degrau de andesito",
  "block.minecraft.red_nether_brick_slab": "degrau de tijolos vermelhos do nether",
  "block.minecraft.polished_andesite_slab": "degrau de andesito polido",
  "block.minecraft.diorite_slab": "degrau de diorito",
  "block.minecraft.scaffolding": "andaime",
  "block.minecraft.iron_door": "porta de ferro",
  "block.minecraft.oak_door": "porta de carvalho",
  "block.minecraft.spruce_door": "porta de abeto",
  "block.minecraft.birch_door": "porta de bétula",
  "block.minecraft.jungle_door": "porta de madeira da selva",
  "block.minecraft.acacia_door": "porta de acácia",
  "block.minecraft.dark_oak_door": "porta de carvalho escuro",
  "block.minecraft.crimson_door": "porta carmesim",
  "block.minecraft.warped_door": "porta deformada",
  "block.minecraft.repeater": "repetidor de redstone",
  "block.minecraft.comparator": "comparador de redstone",
  "block.minecraft.structure_block": "bloco de estrutura",
  "block.minecraft.jigsaw": "bloco de puzzle",
  "item.minecraft.turtle_helmet": "carapaça de tartaruga□□na cabeça:□pontos de proteção: +2",
  "item.minecraft.scute": "pedaço de carapaça",
  "item.minecraft.iron_shovel": "pá de ferro□□na mão principal:□força de ataque: +3.5□velocidade de ataque: -3",
  "item.minecraft.iron_pickaxe": "picareta de ferro□□na mão principal:□força de ataque: +3□velocidade de ataque: -2.8",
  "item.minecraft.iron_axe": "machado de ferro□□na mão principal:□força de ataque: +8□velocidade de ataque: -3.1",
  "item.minecraft.flint_and_steel": "isqueiro",
  "item.minecraft.apple": "maçã",
  "item.minecraft.bow": "arco",
  "item.minecraft.arrow": "flecha",
  "item.minecraft.coal": "carvão",
  "item.minecraft.charcoal": "carvão vegetal",
  "item.minecraft.diamond": "diamante",
  "item.minecraft.iron_ingot": "barra de ferro",
  "item.minecraft.gold_ingot": "barra de ouro",
  "item.minecraft.netherite_ingot": "barra de netherite",
  "item.minecraft.netherite_scrap": "fragmentos de netherite",
  "item.minecraft.iron_sword": "espada de ferro□□na mão principal:□força de ataque: +5□velocidade de ataque: -2.4",
  "item.minecraft.wooden_sword": "espada de madeira□□na mão principal:□força de ataque: +3□velocidade de ataque: -2.4",
  "item.minecraft.wooden_shovel": "pá de madeira□□na mão principal:□força de ataque: +1.5□velocidade de ataque: -3",
  "item.minecraft.wooden_pickaxe": "picareta de madeira□□na mão principal:□força de ataque: +1□velocidade de ataque: -2.8",
  "item.minecraft.wooden_axe": "machado de madeira□□na mão principal:□força de ataque: +6□velocidade de ataque: -3.2",
  "item.minecraft.stone_sword": "espada de pedra□□na mão principal:□força de ataque: +4□velocidade de ataque: -2.4",
  "item.minecraft.stone_shovel": "pá de pedra□□na mão principal:□força de ataque: +2.5□velocidade de ataque: -3",
  "item.minecraft.stone_pickaxe": "picareta de pedra□□na mão principal:□força de ataque: +2□velocidade de ataque: -2.8",
  "item.minecraft.stone_axe": "machado de pedra□□na mão principal:□força de ataque: +8□velocidade de ataque: -3.2",
  "item.minecraft.diamond_sword": "espada de diamante□□na mão principal:□força de ataque: +6□velocidade de ataque: -2.4",
  "item.minecraft.diamond_shovel": "pá de diamante□□na mão principal:□força de ataque: +4.5□velocidade de ataque: -3",
  "item.minecraft.diamond_pickaxe": "picareta de diamante□□na mão principal:□força de ataque: +4□velocidade de ataque: -2.8",
  "item.minecraft.diamond_axe": "machado de diamante□□na mão principal:□força de ataque: +8□velocidade de ataque: -3",
  "item.minecraft.stick": "pau",
  "item.minecraft.bowl": "malga",
  "item.minecraft.mushroom_stew": "estufado de cogumelos",
  "item.minecraft.golden_sword": "espada de ouro□□na mão principal:□força de ataque: +3□velocidade de ataque: -2.4",
  "item.minecraft.golden_shovel": "pá de ouro□□na mão principal:□força de ataque: +1.5□velocidade de ataque: -3",
  "item.minecraft.golden_pickaxe": "picareta de ouro□□na mão principal:□força de ataque: +1□velocidade de ataque: -2.8",
  "item.minecraft.golden_axe": "machado de ouro□□na mão principal:□força de ataque: +6□velocidade de ataque: -3",
  "item.minecraft.netherite_sword": "espada de netherite□□na mão principal:□força de ataque: +7□velocidade de ataque: -2.4",
  "item.minecraft.netherite_shovel": "pá de netherite□□na mão principal:□força de ataque: +5.5□velocidade de ataque: -3",
  "item.minecraft.netherite_pickaxe": "picareta de netherite□□na mão principal:□força de ataque: +5□velocidade de ataque: -2.8",
  "item.minecraft.netherite_axe": "machado de netherite□□na mão principal:□força de ataque: +9□velocidade de ataque: -3",
  "item.minecraft.string": "fio",
  "item.minecraft.feather": "pena",
  "item.minecraft.gunpowder": "pólvora",
  "item.minecraft.wooden_hoe": "enxada de madeira□□na mão principal:□velocidade de ataque: -3",
  "item.minecraft.stone_hoe": "enxada de pedra□□na mão principal:□velocidade de ataque: -2",
  "item.minecraft.iron_hoe": "enxada de ferro□□na mão principal:□velocidade de ataque: -1",
  "item.minecraft.diamond_hoe": "enxada de diamante□□na mão principal:",
  "item.minecraft.golden_hoe": "enxada de ouro□□na mão principal:□velocidade de ataque: -3",
  "item.minecraft.netherite_hoe": "enxada de netherite□□na mão principal:",
  "item.minecraft.wheat_seeds": "sementes de trigo",
  "item.minecraft.wheat": "trigo",
  "item.minecraft.bread": "pão",
  "item.minecraft.leather_helmet": "barrete de couro□□na cabeça:□pontos de proteção: +1",
  "item.minecraft.leather_chestplate": "túnica de couro□□no corpo:□pontos de proteção: +3",
  "item.minecraft.leather_leggings": "perneiras de couro□□nas pernas:□pontos de proteção: +2",
  "item.minecraft.leather_boots": "botas de couro□□nos pés:□pontos de proteção: +1",
  "item.minecraft.chainmail_helmet": "capacete de malha□□na cabeça:□pontos de proteção: +2",
  "item.minecraft.chainmail_chestplate": "peitoral de malha□□no corpo:□pontos de proteção: +5",
  "item.minecraft.chainmail_leggings": "perneiras de malha□□nas pernas:□pontos de proteção: +4",
  "item.minecraft.chainmail_boots": "botas de malha□□nos pés:□pontos de proteção: +1",
  "item.minecraft.iron_helmet": "capacete de ferro□□na cabeça:□pontos de proteção: +2",
  "item.minecraft.iron_chestplate": "peitoral de ferro□□no corpo:□pontos de proteção: +6",
  "item.minecraft.iron_leggings": "perneiras de ferro□□nas pernas:□pontos de proteção: +5",
  "item.minecraft.iron_boots": "botas de ferro□□nos pés:□pontos de proteção: +2",
  "item.minecraft.diamond_helmet": "capacete de diamante□□na cabeça:□pontos de proteção: +3□resistência da armadura: +2",
  "item.minecraft.diamond_chestplate": "peitoral de diamante□□no corpo:□pontos de proteção: +8□resistência da armadura: +2",
  "item.minecraft.diamond_leggings": "perneiras de diamante□□nas pernas:□pontos de proteção: +6□resistência da armadura: +2",
  "item.minecraft.diamond_boots": "botas de diamante□□nos pés:□pontos de proteção: +3□resistência da armadura: +2",
  "item.minecraft.golden_helmet": "capacete de ouro□□na cabeça:□pontos de proteção: +2",
  "item.minecraft.golden_chestplate": "peitoral de ouro□□no corpo:□pontos de proteção: +5",
  "item.minecraft.golden_leggings": "perneiras de ouro□□nas pernas:□pontos de proteção: +3",
  "item.minecraft.golden_boots": "botas de ouro□□nos pés:□pontos de proteção: +1",
  "item.minecraft.netherite_helmet": "capacete de netherite□□na cabeça:□pontos de proteção: +3□resistência da armadura: +3□resistência à repulsão: +1",
  "item.minecraft.netherite_chestplate": "peitoral de netherite□□no corpo:□pontos de proteção: +8□resistência da armadura: +3□resistência à repulsão: +1",
  "item.minecraft.netherite_leggings": "perneiras de netherite□□nas pernas:□pontos de proteção: +6□resistência da armadura: +3□resistência à repulsão: +1",
  "item.minecraft.netherite_boots": "botas de netherite□□nos pés:□pontos de proteção: +3□resistência da armadura: +3□resistência à repulsão: +1",
  "item.minecraft.flint": "sílex",
  "item.minecraft.porkchop": "costeleta de porco crua",
  "item.minecraft.cooked_porkchop": "costeleta de porco assada",
  "item.minecraft.painting": "quadro",
  "item.minecraft.golden_apple": "maçã dourada",
  "item.minecraft.enchanted_golden_apple": "maçã dourada encantada",
  "block.minecraft.oak_sign": "tabuleta de carvalho",
  "block.minecraft.spruce_sign": "tabuleta de abeto",
  "block.minecraft.birch_sign": "tabuleta de bétula",
  "block.minecraft.jungle_sign": "tabuleta de madeira da selva",
  "block.minecraft.acacia_sign": "tabuleta de acácia",
  "block.minecraft.dark_oak_sign": "tabuleta de carvalho escuro",
  "block.minecraft.crimson_sign": "tabuleta carmesim",
  "block.minecraft.warped_sign": "tabuleta deformada",
  "item.minecraft.bucket": "balde",
  "item.minecraft.water_bucket": "balde de água",
  "item.minecraft.lava_bucket": "balde de lava",
  "item.minecraft.minecart": "carrinho de mina",
  "item.minecraft.saddle": "sela",
  "item.minecraft.redstone": "pó de redstone",
  "item.minecraft.snowball": "bola de neve",
  "item.minecraft.oak_boat": "barco de carvalho",
  "item.minecraft.leather": "couro",
  "item.minecraft.milk_bucket": "balde de leite",
  "item.minecraft.pufferfish_bucket": "peixe-balão num balde",
  "item.minecraft.salmon_bucket": "salmão num balde",
  "item.minecraft.cod_bucket": "bacalhau num balde",
  "item.minecraft.tropical_fish_bucket": "peixe tropical num balde",
  "item.minecraft.brick": "tijolo",
  "item.minecraft.clay_ball": "bola de barro",
  "block.minecraft.dried_kelp_block": "bloco de algas secas",
  "item.minecraft.paper": "papel",
  "item.minecraft.book": "livro",
  "item.minecraft.slime_ball": "bola de slime",
  "item.minecraft.chest_minecart": "carrinho de mina com baú",
  "item.minecraft.furnace_minecart": "carrinho de mina com fornalha",
  "item.minecraft.egg": "ovo",
  "item.minecraft.compass": "bússola",
  "item.minecraft.fishing_rod": "cana de pesca",
  "item.minecraft.clock": "relógio",
  "item.minecraft.glowstone_dust": "pó de pedra luminosa",
  "item.minecraft.cod": "bacalhau cru",
  "item.minecraft.salmon": "salmão cru",
  "item.minecraft.tropical_fish": "peixe tropical",
  "item.minecraft.pufferfish": "peixe-balão",
  "item.minecraft.cooked_cod": "bacalhau assado",
  "item.minecraft.cooked_salmon": "salmão assado",
  "item.minecraft.ink_sac": "saco de tinta",
  "item.minecraft.red_dye": "corante vermelho",
  "item.minecraft.green_dye": "corante verde",
  "item.minecraft.cocoa_beans": "sementes de cacau",
  "item.minecraft.lapis_lazuli": "lápis-lazúli",
  "item.minecraft.purple_dye": "corante roxo",
  "item.minecraft.cyan_dye": "corante cíano",
  "item.minecraft.light_gray_dye": "corante cinzento-claro",
  "item.minecraft.gray_dye": "corante cinzento",
  "item.minecraft.pink_dye": "corante rosa",
  "item.minecraft.lime_dye": "corante verde-lima",
  "item.minecraft.yellow_dye": "corante amarelo",
  "item.minecraft.light_blue_dye": "corante azul-claro",
  "item.minecraft.magenta_dye": "corante magenta",
  "item.minecraft.orange_dye": "corante laranja",
  "item.minecraft.bone_meal": "farinha de osso",
  "item.minecraft.blue_dye": "corante azul",
  "item.minecraft.brown_dye": "corante castanho",
  "item.minecraft.black_dye": "corante preto",
  "item.minecraft.white_dye": "corante branco",
  "item.minecraft.bone": "osso",
  "item.minecraft.sugar": "açúcar",
  "block.minecraft.cake": "bolo",
  "block.minecraft.white_bed": "cama branca",
  "block.minecraft.orange_bed": "cama laranja",
  "block.minecraft.magenta_bed": "cama magenta",
  "block.minecraft.light_blue_bed": "cama azul-clara",
  "block.minecraft.yellow_bed": "cama amarela",
  "block.minecraft.lime_bed": "cama verde-lima",
  "block.minecraft.pink_bed": "cama rosa",
  "block.minecraft.gray_bed": "cama cinzenta",
  "block.minecraft.light_gray_bed": "cama cinzento-clara",
  "block.minecraft.cyan_bed": "cama cíano",
  "block.minecraft.purple_bed": "cama roxa",
  "block.minecraft.blue_bed": "cama azul",
  "block.minecraft.brown_bed": "cama castanha",
  "block.minecraft.green_bed": "cama verde",
  "block.minecraft.red_bed": "cama vermelha",
  "block.minecraft.black_bed": "cama preta",
  "item.minecraft.cookie": "bolacha",
  "item.minecraft.filled_map": "mapa□#0",
  "item.minecraft.shears": "tesoura",
  "item.minecraft.melon_slice": "fatia de melancia",
  "item.minecraft.dried_kelp": "algas secas",
  "item.minecraft.pumpkin_seeds": "sementes de abóbora",
  "item.minecraft.melon_seeds": "sementes de melancia",
  "item.minecraft.beef": "bife cru",
  "item.minecraft.cooked_beef": "bife",
  "item.minecraft.chicken": "frango cru",
  "item.minecraft.cooked_chicken": "frango assado",
  "item.minecraft.rotten_flesh": "carne podre",
  "item.minecraft.ender_pearl": "pérola do ender",
  "item.minecraft.blaze_rod": "vara de blaze",
  "item.minecraft.ghast_tear": "lágrima de ghast",
  "item.minecraft.gold_nugget": "pepita de ouro",
  "item.minecraft.nether_wart": "fungo do nether",
  "item.minecraft.potion": "poção impossível□sem efeitos",
  "item.minecraft.glass_bottle": "frasco de vidro",
  "item.minecraft.spider_eye": "olho de aranha",
  "item.minecraft.fermented_spider_eye": "olho de aranha fermentado",
  "item.minecraft.blaze_powder": "pó de blaze",
  "item.minecraft.magma_cream": "creme de magma",
  "block.minecraft.brewing_stand": "fermentador",
  "block.minecraft.cauldron": "caldeirão",
  "item.minecraft.ender_eye": "olho do ender",
  "item.minecraft.glistering_melon_slice": "fatia de melancia reluzente",
  "item.minecraft.bat_spawn_egg": "ovo de invocação de morcego",
  "item.minecraft.bee_spawn_egg": "ovo de invocação de abelha",
  "item.minecraft.blaze_spawn_egg": "ovo de invocação de blaze",
  "item.minecraft.cat_spawn_egg": "ovo de invocação de gato",
  "item.minecraft.cave_spider_spawn_egg": "ovo de invocação de aranha venenosa",
  "item.minecraft.chicken_spawn_egg": "ovo de invocação de galinha",
  "item.minecraft.cod_spawn_egg": "ovo de invocação de bacalhau",
  "item.minecraft.cow_spawn_egg": "ovo de invocação de vaca",
  "item.minecraft.creeper_spawn_egg": "ovo de invocação de creeper",
  "item.minecraft.dolphin_spawn_egg": "ovo de invocação de golfinho",
  "item.minecraft.donkey_spawn_egg": "ovo de invocação de burro",
  "item.minecraft.drowned_spawn_egg": "ovo de invocação de afogado",
  "item.minecraft.elder_guardian_spawn_egg": "ovo de invocação de guardião-mor",
  "item.minecraft.enderman_spawn_egg": "ovo de invocação de enderman",
  "item.minecraft.endermite_spawn_egg": "ovo de invocação de endermite",
  "item.minecraft.evoker_spawn_egg": "ovo de invocação de invocador",
  "item.minecraft.fox_spawn_egg": "ovo de invocação de raposa",
  "item.minecraft.ghast_spawn_egg": "ovo de invocação de ghast",
  "item.minecraft.guardian_spawn_egg": "ovo de invocação de guardião",
  "item.minecraft.hoglin_spawn_egg": "ovo de invocação de hoglin",
  "item.minecraft.horse_spawn_egg": "ovo de invocação de cavalo",
  "item.minecraft.husk_spawn_egg": "ovo de invocação de necrótico",
  "item.minecraft.llama_spawn_egg": "ovo de invocação de lama",
  "item.minecraft.magma_cube_spawn_egg": "ovo de invocação de cubo de magma",
  "item.minecraft.mooshroom_spawn_egg": "ovo de invocação de vacogumelo",
  "item.minecraft.mule_spawn_egg": "ovo de invocação de mula",
  "item.minecraft.ocelot_spawn_egg": "ovo de invocação de ocelote",
  "item.minecraft.panda_spawn_egg": "ovo de invocação de panda",
  "item.minecraft.parrot_spawn_egg": "ovo de invocação de papagaio",
  "item.minecraft.phantom_spawn_egg": "ovo de invocação de espetro",
  "item.minecraft.pig_spawn_egg": "ovo de invocação de porco",
  "item.minecraft.piglin_spawn_egg": "ovo de invocação de piglin",
  "item.minecraft.pillager_spawn_egg": "ovo de invocação de saqueador",
  "item.minecraft.polar_bear_spawn_egg": "ovo de invocação de urso polar",
  "item.minecraft.pufferfish_spawn_egg": "ovo de invocação de peixe-balão",
  "item.minecraft.rabbit_spawn_egg": "ovo de invocação de coelho",
  "item.minecraft.ravager_spawn_egg": "ovo de invocação de devastador",
  "item.minecraft.salmon_spawn_egg": "ovo de invocação de salmão",
  "item.minecraft.sheep_spawn_egg": "ovo de invocação de ovelha",
  "item.minecraft.shulker_spawn_egg": "ovo de invocação de shulker",
  "item.minecraft.silverfish_spawn_egg": "ovo de invocação de lepisma",
  "item.minecraft.skeleton_spawn_egg": "ovo de invocação de esqueleto",
  "item.minecraft.skeleton_horse_spawn_egg": "ovo de invocação de cavalo-esqueleto",
  "item.minecraft.slime_spawn_egg": "ovo de invocação de slime",
  "item.minecraft.spider_spawn_egg": "ovo de invocação de aranha",
  "item.minecraft.squid_spawn_egg": "ovo de invocação de lula",
  "item.minecraft.stray_spawn_egg": "ovo de invocação de desalmado",
  "item.minecraft.strider_spawn_egg": "ovo de invocação de vagante",
  "item.minecraft.trader_llama_spawn_egg": "ovo de invocação de lama de vendedor",
  "item.minecraft.tropical_fish_spawn_egg": "ovo de invocação de peixe tropical",
  "item.minecraft.turtle_spawn_egg": "ovo de invocação de tartaruga",
  "item.minecraft.vex_spawn_egg": "ovo de invocação de vex",
  "item.minecraft.villager_spawn_egg": "ovo de invocação de aldeão",
  "item.minecraft.vindicator_spawn_egg": "ovo de invocação de vindicador",
  "item.minecraft.wandering_trader_spawn_egg": "ovo de invocação de vendedor ambulante",
  "item.minecraft.witch_spawn_egg": "ovo de invocação de bruxa",
  "item.minecraft.wither_skeleton_spawn_egg": "ovo de invocação de esqueleto wither",
  "item.minecraft.wolf_spawn_egg": "ovo de invocação de lobo",
  "item.minecraft.zoglin_spawn_egg": "ovo de invocação de zoglin",
  "item.minecraft.zombie_spawn_egg": "ovo de invocação de zombie",
  "item.minecraft.zombie_horse_spawn_egg": "ovo de invocação de cavalo-zombie",
  "item.minecraft.zombie_villager_spawn_egg": "ovo de invocação de zombie aldeão",
  "item.minecraft.zombified_piglin_spawn_egg": "ovo de invocação de piglin-zombie",
  "item.minecraft.experience_bottle": "frasco encantado",
  "item.minecraft.fire_charge": "projétil de fogo",
  "item.minecraft.writable_book": "livro e pena",
  "item.minecraft.written_book": "livro escrito",
  "item.minecraft.emerald": "esmeralda",
  "item.minecraft.item_frame": "moldura",
  "block.minecraft.flower_pot": "vaso",
  "item.minecraft.carrot": "cenoura",
  "item.minecraft.potato": "batata",
  "item.minecraft.baked_potato": "batata assada",
  "item.minecraft.poisonous_potato": "batata venenosa",
  "item.minecraft.map": "mapa em branco",
  "item.minecraft.golden_carrot": "cenoura dourada",
  "block.minecraft.skeleton_skull": "crânio de esqueleto",
  "block.minecraft.wither_skeleton_skull": "crânio de esqueleto wither",
  "block.minecraft.player_head": "cabeça de jogador",
  "block.minecraft.zombie_head": "cabeça de zombie",
  "block.minecraft.creeper_head": "cabeça de creeper",
  "block.minecraft.dragon_head": "cabeça do dragão",
  "item.minecraft.carrot_on_a_stick": "cenoura num pau",
  "item.minecraft.warped_fungus_on_a_stick": "fungo deformado num pau",
  "item.minecraft.nether_star": "estrela do nether",
  "item.minecraft.pumpkin_pie": "tarte de abóbora",
  "item.minecraft.firework_rocket": "fogo-de-artifício",
  "item.minecraft.firework_star": "estrela de fogo-de-artifício",
  "item.minecraft.enchanted_book": "livro encantado",
  "item.minecraft.nether_brick": "tijolo do nether",
  "item.minecraft.quartz": "quartzo do nether",
  "item.minecraft.tnt_minecart": "carrinho de mina com tnt",
  "item.minecraft.hopper_minecart": "carrinho de mina com funil",
  "item.minecraft.prismarine_shard": "pedaço de prismarinho",
  "item.minecraft.prismarine_crystals": "cristais de prismarinho",
  "item.minecraft.rabbit": "carne de coelho crua",
  "item.minecraft.cooked_rabbit": "carne de coelho assada",
  "item.minecraft.rabbit_stew": "estufado de coelho",
  "item.minecraft.rabbit_foot": "pata de coelho",
  "item.minecraft.rabbit_hide": "pele de coelho",
  "item.minecraft.armor_stand": "suporte para armadura",
  "item.minecraft.iron_horse_armor": "armadura de ferro para cavalo",
  "item.minecraft.golden_horse_armor": "armadura de ouro para cavalo",
  "item.minecraft.diamond_horse_armor": "armadura de diamante para cavalo",
  "item.minecraft.leather_horse_armor": "armadura de couro para cavalo",
  "item.minecraft.lead": "corda",
  "item.minecraft.name_tag": "etiqueta",
  "item.minecraft.command_block_minecart": "carrinho de mina com bloco de comando",
  "item.minecraft.mutton": "carne de carneiro crua",
  "item.minecraft.cooked_mutton": "carne de carneiro assada",
  "block.minecraft.white_banner": "estandarte branco",
  "block.minecraft.orange_banner": "estandarte laranja",
  "block.minecraft.magenta_banner": "estandarte magenta",
  "block.minecraft.light_blue_banner": "estandarte azul-claro",
  "block.minecraft.yellow_banner": "estandarte amarelo",
  "block.minecraft.lime_banner": "estandarte verde-lima",
  "block.minecraft.pink_banner": "estandarte rosa",
  "block.minecraft.gray_banner": "estandarte cinzento",
  "block.minecraft.light_gray_banner": "estandarte cinzento-claro",
  "block.minecraft.cyan_banner": "estandarte cíano",
  "block.minecraft.purple_banner": "estandarte roxo",
  "block.minecraft.blue_banner": "estandarte azul",
  "block.minecraft.brown_banner": "estandarte castanho",
  "block.minecraft.green_banner": "estandarte verde",
  "block.minecraft.red_banner": "estandarte vermelho",
  "block.minecraft.black_banner": "estandarte preto",
  "item.minecraft.end_crystal": "cristal do end",
  "item.minecraft.chorus_fruit": "fruta do coro",
  "item.minecraft.popped_chorus_fruit": "fruta do coro cozinhada",
  "item.minecraft.beetroot": "beterraba",
  "item.minecraft.beetroot_seeds": "sementes de beterraba",
  "item.minecraft.beetroot_soup": "sopa de beterraba",
  "item.minecraft.dragon_breath": "hálito do dragão",
  "item.minecraft.splash_potion": "poção arremessável impossível□sem efeitos",
  "item.minecraft.spectral_arrow": "flecha espetral",
  "item.minecraft.tipped_arrow": "flecha de efeito impossível□sem efeitos",
  "item.minecraft.lingering_potion": "poção prolongada impossível□sem efeitos",
  "item.minecraft.shield": "escudo",
  "item.minecraft.elytra": "élitros",
  "item.minecraft.spruce_boat": "barco de abeto",
  "item.minecraft.birch_boat": "barco de bétula",
  "item.minecraft.jungle_boat": "barco de madeira da selva",
  "item.minecraft.acacia_boat": "barco de acácia",
  "item.minecraft.dark_oak_boat": "barco de carvalho escuro",
  "item.minecraft.totem_of_undying": "totem da imortalidade",
  "item.minecraft.shulker_shell": "casca de shulker",
  "item.minecraft.iron_nugget": "pepita de ferro",
  "item.minecraft.knowledge_book": "enciclopédia",
  "item.minecraft.debug_stick": "pau de depuração",
  "item.minecraft.music_disc_13": "disco de música□c418 — 13",
  "item.minecraft.music_disc_cat": "disco de música□c418 — cat",
  "item.minecraft.music_disc_blocks": "disco de música□c418 — blocks",
  "item.minecraft.music_disc_chirp": "disco de música□c418 — chirp",
  "item.minecraft.music_disc_far": "disco de música□c418 — far",
  "item.minecraft.music_disc_mall": "disco de música□c418 — mall",
  "item.minecraft.music_disc_mellohi": "disco de música□c418 — mellohi",
  "item.minecraft.music_disc_stal": "disco de música□c418 — stal",
  "item.minecraft.music_disc_strad": "disco de música□c418 — strad",
  "item.minecraft.music_disc_ward": "disco de música□c418 — ward",
  "item.minecraft.music_disc_11": "disco de música□c418 — 11",
  "item.minecraft.music_disc_wait": "disco de música□c418 — wait",
  "item.minecraft.music_disc_pigstep": "disco de música□lena raine — pigstep",
  "item.minecraft.trident": "tridente□□na mão principal:□força de ataque: +8□velocidade de ataque: -2.9",
  "item.minecraft.phantom_membrane": "membrana de espetro",
  "item.minecraft.nautilus_shell": "concha de náutilo",
  "item.minecraft.heart_of_the_sea": "coração do mar",
  "item.minecraft.crossbow": "besta",
  "item.minecraft.suspicious_stew": "estufado suspeito",
  "block.minecraft.loom": "tear",
  "item.minecraft.flower_banner_pattern": "padrão para estandarte□emblema de flor",
  "item.minecraft.creeper_banner_pattern": "padrão para estandarte□emblema de creeper",
  "item.minecraft.skull_banner_pattern": "padrão para estandarte□emblema de caveira",
  "item.minecraft.mojang_banner_pattern": "padrão para estandarte□insígnia",
  "item.minecraft.globe_banner_pattern": "padrão para estandarte□globo",
  "item.minecraft.piglin_banner_pattern": "padrão para estandarte□focinho",
  "block.minecraft.composter": "compostor",
  "block.minecraft.barrel": "barril",
  "block.minecraft.smoker": "defumador",
  "block.minecraft.blast_furnace": "alto-forno",
  "block.minecraft.cartography_table": "mesa cartográfica",
  "block.minecraft.fletching_table": "mesa de flechas",
  "block.minecraft.grindstone": "mó",
  "block.minecraft.lectern": "atril",
  "block.minecraft.smithing_table": "mesa de ferraria",
  "block.minecraft.stonecutter": "cortador de pedras",
  "block.minecraft.bell": "sino",
  "block.minecraft.lantern": "lanterna",
  "block.minecraft.soul_lantern": "lanterna das almas",
  "item.minecraft.sweet_berries": "bagas doces",
  "block.minecraft.campfire": "fogueira",
  "block.minecraft.soul_campfire": "fogueira das almas",
  "block.minecraft.shroomlight": "cogumelo luminoso",
  "item.minecraft.honeycomb": "favo de mel",
  "block.minecraft.bee_nest": "colmeia",
  "block.minecraft.beehive": "colmeia artificial",
  "item.minecraft.honey_bottle": "frasco de mel",
  "block.minecraft.honey_block": "bloco de mel",
  "block.minecraft.honeycomb_block": "bloco de favos de mel",
  "block.minecraft.lodestone": "magnetite",
  "block.minecraft.netherite_block": "bloco de netherite",
  "block.minecraft.ancient_debris": "detritos ancestrais",
  "block.minecraft.target": "alvo",
  "block.minecraft.crying_obsidian": "obsidiana lacrimejante",
  "block.minecraft.blackstone": "negrito",
  "block.minecraft.blackstone_slab": "degrau de negrito",
  "block.minecraft.blackstone_stairs": "escadas de negrito",
  "block.minecraft.gilded_blackstone": "negrito dourado",
  "block.minecraft.polished_blackstone": "negrito polido",
  "block.minecraft.polished_blackstone_slab": "degrau de negrito polido",
  "block.minecraft.polished_blackstone_stairs": "escadas de negrito polido",
  "block.minecraft.chiseled_polished_blackstone": "negrito polido esculpido",
  "block.minecraft.polished_blackstone_bricks": "tijolos de negrito polido",
  "block.minecraft.polished_blackstone_brick_slab": "degrau de tijolos de negrito polido",
  "block.minecraft.polished_blackstone_brick_stairs": "escada de tijolos de negrito polido",
  "block.minecraft.cracked_polished_blackstone_bricks": "tijolos de negrito polido rachados",
  "block.minecraft.respawn_anchor": "âncora de renascimento",
}
export const pt_pt = items; 
